// @flow
import React, { useRef, useEffect } from 'react';
import md5 from 'blueimp-md5';
import * as Sentry from '@sentry/browser';

import Loading from '../../components/loading/Loading';
import useAuth from '../../hooks/auth';
import usePods from '../../hooks/pods';
import useFirebase from '../../hooks/firebase';
import useUser from '../../hooks/user';

const TokenAuth = ({ history, match }: Object) => {
	const [auth, , , tokenAuth] = useAuth(); 
	const { authenticating = false, error = null } = auth;
	const [podData, , resetSelectedPod] = usePods();
	const initateAuth = useRef(false);
	const { params: { token = '' } = {} } = match;
	const [ logEvent, , setUserId ] = useFirebase();
	const [{mobile} = {}] = useUser();

	useEffect(() => {
		if (initateAuth.current && !authenticating) {
			const state = {};
			if (podData.selectedPod) {
				state.selectPod = podData.selectedPod.vm_imei_id;
				resetSelectedPod();
			}

			if (error) {
        return history.replace('/login');
			}
			
			history.replace({
				pathname: '/tips',
				state
			});
			logEvent('logged_in_using_personalised_url');
			setUserId(md5(mobile));
			Sentry.configureScope(scope => {
				scope.setUser({ id: mobile });
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [authenticating]);

	useEffect(() => {
		// if (sessionId) {
		// 	return history.replace('/products')
		// }
		initateAuth.current = true;
		tokenAuth(token);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<section style={{ minHeight: 'inherit', height: 'inherit' }}>
			<Loading message='Authenticating. Please do not refresh' style={{ color: 'white' }} />
		</section>
	);
};

export default TokenAuth;
